import { gqlClient } from '@/api/graphql-client';
import materialKeys from '@/api/queries/materials/keyFactory';
import { graphql } from '@/gql';
import { ProductSpecCategory } from '@/gql/graphql';
import { useQuery } from '@tanstack/react-query';

const ProductSpecsQuery = graphql(`
  query ProductSpecs($category: ProductSpecCategory!, $searchTerm: String) {
    productSpecs(category: $category, searchTerm: $searchTerm) {
      items {
        productSpec {
          id
          name
          category
          manufacturer
          modelNumber
          domesticHotWaterLitres
          nominalOutputKw
          scopAtDefaultFlow
          dimensions {
            heightMm
            widthMm
            depthMm
          }
        }
        isPreferred
        material {
          id
          suppliedBy {
            id
          }
        }
        lineItem {
          id
        }
      }
      totalCount
    }
  }
`);

const useSearchProductSpecs = (
  category: ProductSpecCategory,
  searchTerm?: string
) => {
  const { data, ...rest } = useQuery({
    queryKey: materialKeys.productSpecs(category, searchTerm),
    queryFn: () => {
      return gqlClient.request(ProductSpecsQuery, {
        category,
        searchTerm: searchTerm || undefined,
      });
    },
    enabled: !!searchTerm,
  });

  return { data: data?.productSpecs?.items, ...rest };
};

export default useSearchProductSpecs;
